<template>
	<div id="info">
		<div style="width: 100%;height: auto;text-align: center;background-color: white;margin-top: 10px;">
			<img :src="user.photo|addPath" style="width: 100px;height: 100px;"/>
		</div>
		<van-cell-group>
			<van-cell title="姓名" :value="user.name" />
			<van-cell title="国籍" :value="user.nationality" />
			<van-cell title="性别" :value="user.sex" />
			<van-cell title="手机" :value="user.phonenum" />
			<van-cell title="身份证号" :value="user.idnumber" />
			<van-cell title="出生日期" :value="user.birthdate|formatDate" />
			<van-cell title="民族" :value="user.nation" />
			<van-cell title="特长" :value="user.speciality" />
			<van-cell title="地区" :value="user.worknature" />
			<van-cell title="详细地址" :value="user.contactAddress" />
			<van-cell title="邮编" :value="user.workpost" />
			<van-cell title="Email" :value="user.email" />
			<van-cell title="工作单位" :value="user.workname" />
			<van-cell title="受教育程度" :value="user.education" />
			<van-cell title="毕业院校" :value="user.graduateInstitutions" />
			<van-cell title="专业名称" :value="user.professional" />
			<van-cell title="服务项目" :value="user.worktitle" />
		</van-cell-group>
	</div>
</template>

<script>
	import { Field, Cell, CellGroup, Button, Notify, RadioGroup, Radio, Checkbox, CheckboxGroup, Toast, Area, Popup, Dialog } from 'vant';
	import global from '@/api/global';
	import axios from 'axios';
	import Vue from 'vue';
	import { htmlspecialchars_decode, formatDate } from '@/js/common.js';
	import areaList from '@/js/area.js';
	import VueCookies from 'vue-cookies';
	Vue.use(VueCookies);
	export default {
		components: {
			[Field.name]: Field,
			[Cell.name]: Cell,
			[CellGroup.name]: CellGroup,
			[Button.name]: Button,
			[Notify.name]: Notify,
			[RadioGroup.name]: RadioGroup,
			[Radio.name]: Radio,
			[Checkbox.name]: Checkbox,
			[CheckboxGroup.name]: CheckboxGroup,
			[Toast.name]: Toast,
			[Area.name]: Area,
			[Popup.name]: Popup,
			[Dialog.name]: Dialog
		},
		filters: {
			formatDate(time) {
				if(time == null){
					return "";
				}
				return formatDate(time, 'yyyy-MM-dd');
			},
			addPath(path) {
				return global.resoursePhoto +'/'+ path;
			}
		},
		data() {
			return {
				user: {

				}
			}
		},
		created() {
			this.info();
		},
		methods: {
			//获取用户信息
			info() {
				Toast.loading({
					mask: true,
					message: '正在提交...',
					duration: 0
				});
				axios({
					method: 'post',
					url: global.baseURL + 'appsite/phoneUser/otherUserInfo',
					params: {
						"id": this.$route.query.id,
						"auth_token": this.$cookies.get("auth_token")
					}
				}).then((resp) => {
					this.user = resp.data;
					console.log(this.user);
					Toast.clear();
				}).catch(resp => {
					Toast.clear();
					Toast.fail('请求失败');
				});
			}
		}
	}
</script>

<style>
	#info .active_button {
		background-color: orangered !important
	}
	
	#info * {
		font-size: 14px;
	}
	
	#info .van-radio-lable {
		margin-top: 10px;
		width: 60px;
		text-align: center;
		font-size: 14px;
		margin-right: 40px;
	}
	
	#info .van-radio-group {
		height: 44px;
		display: flex;
	}
	
	#info .van-radio {
		margin-top: 10px;
		flex: 1;
		max-width: 20%;
	}
</style>